import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchClusters,
  SearchClustersVariables
} from "./types/SearchClusters";

export const searchClusters = gql`
  ${pageInfoFragment}
  query SearchClusters($after: String, $first: Int!, $query: String!) {
    search: clusters(after: $after, first: $first, filter: { search: $query }) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchClusters, SearchClustersVariables>(
  searchClusters
);
